import { render, staticRenderFns } from "./ProductPause.vue?vue&type=template&id=0eb4c6f0&"
import script from "./ProductPause.vue?vue&type=script&lang=js&"
export * from "./ProductPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports